import React from 'react';
import Icon from '../../artzu-ui/src/Icon';

const Header = ({ header, backAction }) => (
  <div className="promo-head">
    <a href="javascript:void(0)" onClick={backAction}>
      <Icon size="sm" name="BackArrow" color="#414141" />
    </a>
    <p>{header}</p>
    <div className="heading-filler" />
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Promotion/Header.js